(function ($, Drupal, once, drupalSettings) {
  'use strict';

  var mapToggleContentVisible = "list";

  Drupal.behaviors.dlaMapToggle = {
    attach: function (context, settings) {
      var self = this;
      // $('.dla-map-toggle').once().each(function () {
      $(once('dla-processed-map-toggle-dinela', '.dla-map-toggle')).each(function() {

        // Show map or list by default based on url param show-tab
        let params = new URLSearchParams(window.location.search);
        let showTab = params.get("show-tab");
        if (showTab == "map") {
          mapToggleContentVisible = "map";
          self.showMap(context);
        } else if (showTab == "list") {
          mapToggleContentVisible = "list";
          self.showList(context);
        }

        // Show list or map based on click on map toggle
        $('.dla-map-toggle .dla-btn').on('click',
          function(e) {
            if ($(this).hasClass('dla-map-toggle__btn--map')) {
              mapToggleContentVisible = "map";
              self.showMap(context);
            }
            if ($(this).hasClass('dla-map-toggle__btn--list')) {
              mapToggleContentVisible = "list";
              self.showList(context);
            }
          }
        );
      });

      // Add some custom functions that fire whenever a user has submitted the filter form
      $(document).ajaxComplete(function(event, xhr, settings) {
        // Detect ajax views filter event
        let settings_url = settings.url.substring(0, settings.url.indexOf('?'));
        // if (settings.url == "/views/ajax?_wrapper_format=drupal_ajax"){
        if (settings_url === "/views/ajax") {
          // apply formatting to both map and list since every time ajax form submits happen, the styles of the list and map
          // elements are lost. Applying the showList and showMap functions each time this happens ensures that those elements
          // maintain their current style and visibility settings
          if (mapToggleContentVisible == "list") {
            self.showList(context);
          }
          if (mapToggleContentVisible == "map") {
            self.showMap(context);
          }
        }
      });

    },

    showMap: function (context) {
      var self = this;
      $('.dla-map-toggle__btn--list').show();
      $('.dla-map-toggle__btn--map').hide();
      $('.dla-map-toggle__content--map').css({
        "visibility": "visible",
        "position": "relative"
      });
      $('.dla-map-toggle__content--list').css({
        "visibility": "hidden",
        "position": "fixed"
      });
      // scroll to top
      if ($('[role="contentinfo"].messages').length) {
        $('html, body').animate({scrollTop: $('.paragraph--type--carousel').height() + $('[role="contentinfo"].messages').height()}, 100);
      } else {
        $('html, body').animate({scrollTop: $('.paragraph--type--carousel').height()}, 100);
      }
      if (self.isMobile(context)) {
        // Get map to be edge to edge on mobile
        //$('.view-display-id-dinela > .view__header + .content-constrained--md, .view-display-id-dinela > .view__footer > .content-constrained--md, .dla-map-toggle__content > .content-constrained--md').css("display", "block");
        $('.view-display-id-dinela > .view__footer > .content-constrained--md, .dla-map-toggle__content > .content-constrained--md').css("grid-template-columns", "max-content");
      }
      self.mapBoxInvalidateSize(context);
      $('.table-header-placeholder').css('visibility', 'hidden');
    },

    showList: function (context) {

      var self = this;
      $('.dla-map-toggle__btn--map').show();
      $('.dla-map-toggle__btn--list').hide();
      $('.dla-map-toggle__content--list').css({
        "visibility": "visible",
        "position": "relative"
      });
      $('.dla-map-toggle__content--map').css({
        "visibility": "hidden",
        "position": "fixed"
      });
      // if (self.isMobile(context)) {
      //$('.view-display-id-dinela > .view__header + .content-constrained--md').css("display", "grid");
      //$('.view-display-id-dinela > .view__header + .content-constrained--md, .view-display-id-dinela > .view__footer > .content-constrained--md, .dla-map-toggle__content > .content-constrained--md').css("display", "grid");
      // }
      self.mapBoxInvalidateSize(context);
      $('.table-header-placeholder').css('visibility', 'visible');
    },

    mapBoxInvalidateSize: function (context) {
      // Previously, some tiles on the map were missing at larger screen size after a toggle event
      // Run this command to ensure all tiles load on Dine LA map load after map/list toggle events
      let guideMapbox = Drupal.Leaflet["leaflet-map-view-dinela-block-dinela-map"].lMap;
      guideMapbox.invalidateSize();
      // Triggering a window resize here seems to help ensure map renders correctly with all tiles loaded and at appropriate zoom
      $(window).trigger('resize');
      var evt = window.document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    },

    isMobile: function (context) {
      var isMobile = false; //initiate as false
      // device detection
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))
        || $(window).width() <= 768
      ) {
        isMobile = true;
      }
      return isMobile;
    },

  };

})(jQuery, Drupal, once, drupalSettings);
